import type { CSSProperties, ReactElement } from 'react';

import roxyHero from './assets/roxy-hero-clear.png';

const portraitStyle: CSSProperties = {
  display: 'block',
  width: '8.5rem',
  height: '8.5rem',
  objectFit: 'contain',
  flexShrink: 0,
  background: 'transparent',
  borderRadius: 0,
  boxShadow: 'none',
  filter: 'drop-shadow(0 0 10px color-mix(in srgb, var(--fm-color-secondary) 32%, transparent))',
};

export function RoxyClearHero(): ReactElement {
  return (
    <img
      src={roxyHero}
      alt=""
      width={160}
      height={160}
      className="roxy-page__portrait"
      style={portraitStyle}
      draggable={false}
    />
  );
}
